<template>
    <div class="content_wrap">
        <div class="wrap">
            <div class="password_main risk-content">
                <div class="password_main_top ft24">
                    <span class="second_font">批次修改</span>
                </div>
                <div class="risk-main">
                    <div id="components-form-demo-advanced-search">
                        <a-form class="ant-advanced-search-form" :form="form" @submit="handleSearch">
                            <a-row :gutter="24">
                                <a-col :span="12">
                                    <a-form-item :label="`批次号`">
                                        <a-input v-decorator="[`batchNo`]" placeholder="请输入批次号" />
                                    </a-form-item>
                                </a-col>

                                <a-col :span="12" :style="{ textAlign: 'left', marginTop: '5px' }">
                                    <a-button type="primary" html-type="submit">
                                        查询
                                    </a-button>
                                    <a-button :style="{ marginLeft: '8px' }" @click="handleReset">
                                        重置
                                    </a-button>
                                </a-col>
                            </a-row>
                        </a-form>
                        <a-alert v-if="batchStatus === '1'" style="margin-bottom: 16px;" message="批次状态：核验完成" type="info" show-icon />
                        <a-alert v-if="batchStatus === '0'" style="margin-bottom: 16px;" message="批次状态：进行中" type="info" show-icon />
                        <a-table @change="pageOnChange" :locale="{ emptyText: '暂无数据' }" bordered
                            :data-source="dataSource" :columns="columns">
                            <span slot="operation" slot-scope="text,record">
                                <a href="javascript:;"  @click="() => onChange(record)" :disabled="!batchStatus">修改</a>
                            </span>
                        </a-table>

                        <div class="risk-content-footer">
                            <a-button @click="handleCancel" class="mr10">
                                返回
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BatchModal v-if="visible" :batchNo="batchNo" :formData="formData" :visible="visible"
            @setModalIsShow="setModalIsShow" @getTableList="getTableList"></BatchModal>
    </div>

</template>
<script>
import BatchModal from './BatchModal.vue'
export default {
    components: {
        BatchModal
    },
    data() {
        return {
            form: this.$form.createForm(this, { name: 'batch' }),
            dataSource: [],
            columns: [
                {
                    title: '发票号码',
                    dataIndex: 'invoiceNumber',
                },
                {
                    title: '发票代码',
                    dataIndex: 'invoiceCode',
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    customRender: (text) => {
                        const statusEnum = {
                            0: '正常',
                            1: '失控',
                            2: '作废',
                            3: '红冲',
                            4: '异常',
                            7: '部分红冲',
                            8: '全额红冲'
                        }
                        return statusEnum[text]
                    }
                },
                {
                    title: '编码',
                    dataIndex: 'errCode',
                },
                {
                    title: '文字',
                    dataIndex: 'reason',
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    scopedSlots: { customRender: 'operation' },
                },
            ],
            visible: false,
            formData: {},
            batchNo: '',
            batchStatus: '' // 0 - 核验中  1 - 核验完成
        };
    },
    methods: {
        handleSearch(e) {
            e.preventDefault();
            if (!this.form.getFieldsValue().batchNo) return this.$message.warning('请先输入批次号再进行查找！')
            this.batchNo = this.form.getFieldsValue().batchNo
            this.getTableList()
        },
        getTableList(params = {}) {
            let { pageNumber = 1, pageSize = 10 } = params
            this.http.post('/ystOpenPlatformBff/tool/batchCheckDetail', { batchNo: this.batchNo, pageNumber, pageSize }, res => {
                if (res.success) {
                    this.dataSource = res.data.list
                    this.batchStatus = res.data.status
                } else {
                    this.$message.warning(res.message)
                    this.dataSource = []
                    this.batchStatus = ''
                }
            })
        },
        handleReset() {
            this.form.resetFields();
            this.dataSource = []
            this.batchNo = ''
        },
        setModalIsShow(flag) {
            this.visible = flag
        },
        // 页面修改
        pageOnChange(page) {
            let params = {
                pageNumber: page.current,
                pageSize: page.pageSize
            }
            this.getTableList(params)
        },
        // 点击了表格中的某一行修改
        onChange(record) {
            this.formData = record
            this.visible = true
        },
        // 跳转回上一个页面
        handleCancel() {
            this.$router.push('/developCenter/invoiceCheck')
        },

    },
};
</script>
<style lang="scss">
.ant-advanced-search-form {
    padding: 15px 20px 0px;
}

.ant-advanced-search-form .ant-form-item {
    display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
}

#components-form-demo-advanced-search .ant-form {
    max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
}

.risk-content.password_main {
    width: 800px;

    .risk-content-footer {
        margin-top: 15px;
        text-align: right;
    }

    .risk-main {
        padding: 15px;
    }
}
</style>


// WEBPACK FOOTER //
// src/page/BatchData.vue